module.exports = __webpack_public_path__ + "static/main_logo_mobile_white-601dbb97f912c0bb661f71dacfa7d911.svg";